<template>
  <div class="external-frame-container">
    <!-- 左侧遮罩层，遮挡外部系统的侧边栏 -->
    <div class="left-mask"></div>
    
    <!-- iframe 容器 -->
    <div class="iframe-wrapper">
      <iframe 
        :src="frameUrl" 
        frameborder="0"
        class="external-iframe"
        @load="onIframeLoad"
      ></iframe>
      
      <!-- 加载中提示 -->
      <div v-if="loading" class="loading-overlay">
        <a-spin size="large" tip="加载中..." />
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted } from 'vue';
import { useRoute } from 'vue-router';
import { TAG_ADMIN_BASE_URL, TAG_ADMIN_CONFIG } from '../config/tagAdmin';

const route = useRoute();
const loading = ref(true);

// 使用配置文件中的基础URL
const baseUrl = TAG_ADMIN_BASE_URL;

// 输出配置信息，方便调试（生产环境也需要查看）
console.log('标签管理系统配置:', TAG_ADMIN_CONFIG);
console.log('当前使用的URL:', baseUrl);
// 新代码标识 - 2026-01-14 14:00:00 - 基于域名动态判断
console.log('✅ 新代码已加载 - Build Time: 2026-01-14 14:00:00 - 基于当前访问域名动态选择URL');

// 页面路径映射（路由参数 -> 页面路径）
const pagePathMap = {
  'tag-types': '/tag_types',
  'independent-tags': '/independent_tags',
  'cascade-tags': '/cascade_tags',
  'composite-tags': '/composite_tags',
  'system-tags': '/system_tags',
  'ecu-brand-tags': '/ecu_brand_tags',
  'ecu-tags': '/ecu_tags'
};

// 根据路由参数获取 iframe URL
const frameUrl = computed(() => {
  const page = route.params.page;
  const pagePath = pagePathMap[page] || '';
  if (!pagePath) {
    return '';
  }
  // 确保baseUrl以/结尾，pagePath以/开头，避免重复
  const base = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const path = pagePath.startsWith('/') ? pagePath : `/${pagePath}`;
  return `${base}${path}`;
});

const onIframeLoad = () => {
  loading.value = false;
};

onMounted(() => {
  // 3秒后自动隐藏加载提示（防止跨域无法触发 load 事件）
  setTimeout(() => {
    loading.value = false;
  }, 3000);
});
</script>

<style scoped>
.external-frame-container {
  position: relative;
  width: 100%;
  height: calc(100vh - 0px);
  overflow: hidden;
  background: #f0f2f5;
}

/* 左侧遮罩层 - 遮挡外部系统的260px侧边栏 */
.left-mask {
  position: absolute;
  top: 0;
  left: 0;
  width: 0px;  /* 遮罩宽度，设为0因为我们用负margin */
  height: 100%;
  background: #f0f2f5;
  z-index: 10;
}

.iframe-wrapper {
  position: relative;
  width: calc(100% + 260px);  /* 扩展宽度 */
  height: 100%;
  margin-left: -260px;  /* 左移隐藏外部系统侧边栏 */
  overflow: hidden;
}

.external-iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.loading-overlay {
  position: absolute;
  top: 0;
  left: 260px;  /* 偏移回正确位置 */
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  background: rgba(255, 255, 255, 0.9);
  z-index: 20;
}
</style>

